(function () {
  const MOBILE_MAX = 767;

  function getHeadingLabel(heading) {
    return (heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function normalizeTocLabel(text) {
    return text.replace(/^\d+[\.)]\s+/, '').trim();
  }

  function slugify(text, usedIds) {
    const map = {
      á: 'a', à: 'a', ä: 'a', â: 'a',
      é: 'e', è: 'e', ë: 'e', ê: 'e',
      í: 'i', ì: 'i', ï: 'i', î: 'i',
      ó: 'o', ò: 'o', ö: 'o', ô: 'o',
      ú: 'u', ù: 'u', ü: 'u', û: 'u',
      ñ: 'n', ç: 'c',
    };

    let slug = (text || '')
      .trim()
      .toLowerCase()
      .replace(/[\u00e1\u00e0\u00e4\u00e2\u00e9\u00e8\u00eb\u00ea\u00ed\u00ec\u00ef\u00ee\u00f3\u00f2\u00f6\u00f4\u00fa\u00f9\u00fc\u00fb\u00f1\u00e7]/g, (char) => map[char] || char)
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    if (!slug) slug = 'seccion';
    if (slug.length > 80) slug = slug.slice(0, 80).replace(/-$/, '');

    let candidate = slug;
    let index = 2;
    while (usedIds.has(candidate)) {
      candidate = `${slug}-${index}`;
      index += 1;
    }

    usedIds.add(candidate);
    return candidate;
  }

  function getValidHeadings(content) {
    const headings = Array.from(content.querySelectorAll('h2, h3'));

    headings.forEach((heading) => {
      if (!getHeadingLabel(heading)) {
        heading.hidden = true;
      }
    });

    return headings.filter((heading) => getHeadingLabel(heading));
  }

  function ensureHeadingIds(headings) {
    const usedIds = new Set();

    headings.forEach((heading) => {
      if (heading.id) {
        usedIds.add(heading.id);
      }
    });

    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = slugify(getHeadingLabel(heading), usedIds);
      }
    });
  }

  function buildList(headings) {
    const list = document.createElement('ol');
    list.className = 'm-article-toc__list';

    let currentH2Item = null;
    let currentSubList = null;

    headings.forEach((heading) => {
      const label = normalizeTocLabel(getHeadingLabel(heading));
      if (!label) return;

      const item = document.createElement('li');
      item.className = 'm-article-toc__item';

      const link = document.createElement('a');
      link.className = 'm-article-toc__link';
      link.href = `#${heading.id}`;
      link.textContent = label;
      item.appendChild(link);

      if (heading.tagName === 'H2') {
        list.appendChild(item);
        currentH2Item = item;
        currentSubList = null;
        return;
      }

      if (!currentH2Item) {
        list.appendChild(item);
        return;
      }

      if (!currentSubList) {
        currentSubList = document.createElement('ol');
        currentSubList.className = 'm-article-toc__sublist';
        currentH2Item.appendChild(currentSubList);
      }

      currentSubList.appendChild(item);
    });

    return list;
  }

  function buildToc(content, settings) {
    const headings = getValidHeadings(content);
    if (headings.length < settings.minHeadings) {
      return null;
    }

    ensureHeadingIds(headings);

    const nav = document.createElement('nav');
    nav.className = 'm-article-toc';
    nav.setAttribute('aria-label', settings.title);

    const header = document.createElement('div');
    header.className = 'm-article-toc__header';

    const title = document.createElement('p');
    title.className = 'm-article-toc__title';
    title.textContent = settings.title;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'm-article-toc__toggle';
    toggle.setAttribute('aria-expanded', window.innerWidth > MOBILE_MAX ? 'true' : 'false');
    toggle.setAttribute('aria-controls', 'article-toc-panel');
    toggle.innerHTML = `<span class="m-article-toc__toggle-text">${settings.toggleHide}</span><svg class="m-article-toc__toggle-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

    header.appendChild(title);
    header.appendChild(toggle);

    const panel = document.createElement('div');
    panel.className = 'm-article-toc__panel';
    panel.id = 'article-toc-panel';
    panel.appendChild(buildList(headings));

    nav.appendChild(header);
    nav.appendChild(panel);

    const setCollapsed = (collapsed) => {
      nav.classList.toggle('is-collapsed', collapsed);
      toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      toggle.querySelector('.m-article-toc__toggle-text').textContent = collapsed
        ? settings.toggleShow
        : settings.toggleHide;
    };

    toggle.addEventListener('click', () => {
      setCollapsed(!nav.classList.contains('is-collapsed'));
    });

    if (window.innerWidth <= MOBILE_MAX) {
      setCollapsed(true);
    }

    return { nav, firstHeading: headings[0] };
  }

  function initArticleToc() {
    document.querySelectorAll('[data-article-toc]').forEach((content) => {
      if (content.dataset.tocInitialized === 'true') return;

      const settings = {
        minHeadings: parseInt(content.dataset.tocMin || '3', 10),
        title: content.dataset.tocTitle || 'Tabla de contenidos',
        toggleShow: content.dataset.tocShow || 'Mostrar',
        toggleHide: content.dataset.tocHide || 'Ocultar',
      };

      const result = buildToc(content, settings);
      if (!result) return;

      content.insertBefore(result.nav, result.firstHeading);
      content.dataset.tocInitialized = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleToc);
  } else {
    initArticleToc();
  }
})();
